module.exports = "/_next/static/images/81a77813aa1b385329b42c956da5f565-man-looking-up-smiling-xs@1x.jpg.webp";